import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AppService from "../../../services/app.service";
import Loader from '../../../components/loader';
import Table from "../../../components/Table";
import Layout from "../../../layout/Layout";

interface ClientOutreachSummary {
    id: number;
    accountId: number;
    accountName: string;
    accountType: string;
    simPlayCountLast90d: number;
    usageTier: string;
    usageDataTier: string | null;
    usageFeedbackTier: string | null;
    editStatus: string;
}

const ClientOutreachSummaries = (props: any) => {
    const [data, setData] = useState<ClientOutreachSummary[]>([]);
    const [loading, setLoading] = useState(false);
    const [totalElements, setTotalElements] = useState(0);

    const columnSchema = [
        {
            dataField: "id",
            text: "ID",
            sort: true,
            classes: "content-body",
            headerStyle: { minWidth: 50 },
            headerClasses: "table_header_color",
            headerAlign: "left",
            align: "left",
        },
        {
            dataField: "accountName",
            text: "Account Name",
            sort: true,
            sortField: "account_name",
            classes: "content-body",
            headerClasses: "table_header_color",
            headerAlign: "left",
            align: "left",
        },
        {
            dataField: "accountType",
            text: "Account Type",
            sort: true,
            sortField: "account_type",
            classes: "content-body",
            headerClasses: "table_header_color",
            headerAlign: "left",
            align: "left",
        },
        {
            dataField: "simPlayCountLast90d",
            text: "Sim Play Count 90 Days",
            sort: true,
            sortField: "sim_play_count_last_90d",
            classes: "content-body",
            headerClasses: "table_header_color",
            headerAlign: "center",
            align: "center",
        },
        {
            dataField: "usageTier",
            text: "Usage Tier",
            sort: true,
            sortField: "usage_tier",
            classes: "content-body",
            headerClasses: "table_header_color",
            headerAlign: "left",
            align: "left",
        },
        {
            dataField: "usageDataTier",
            text: "Data Tier",
            sort: true,
            sortField: "usage_data_tier",
            classes: "content-body",
            headerClasses: "table_header_color",
            headerAlign: "left",
            align: "left",
        },
        {
            dataField: "usageFeedbackTier",
            text: "Feedback Tier",
            sort: true,
            sortField: "usage_feedback_tier",
            classes: "content-body",
            headerClasses: "table_header_color",
            headerAlign: "left",
            align: "left",
        },
        {
            dataField: "editStatus",
            text: "Status",
            sort: true,
            sortField: "edit_status",
            classes: "content-body",
            headerClasses: "table_header_color",
            headerAlign: "center",
            align: "center"
        },
        {
            dataField: "action",
            text: "Action",
            classes: "action text-center",
            headerStyle: { width: 80 },
            headerClasses: "table_header_color text-center",
            headerAlign: "center",
            align: "center",
            formatter: (_, record) => (
                <Link
                    className="btn btn-primary btn-sm"
                    to={`/client-outreach-summaries/edit/${record.id}`}
                    title="Update Summary"
                >
                    <i className="fa fa-edit" />
                </Link>
            )
        }
    ];

    const loadData = async (url: string) => {
        setLoading(true);
        try {
            const response = await AppService.getAll(url);
            if (response.status === 200 && response.data?.data) {
                const responseData = response.data.data;
                setData(responseData.content || []);
                setTotalElements(responseData.totalRecords || 0);
            } else {
                setData([]);
                setTotalElements(0);
            }
        } catch (error) {
            console.error('Error loading client outreach summaries:', error);
            setData([]);
            setTotalElements(0);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadData('client-outreach/list?filter_value=&page_number=1&page_size=10&sort_column=id&sort_order=asc');
    }, []);

    return (
        <div>
            <Layout
                title="Client Outreach Summary Management"
                history={props.history}
                activeCOSLink={true}
                showBreadCrumb={true}
            >
                <section className="tables">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-header d-flex align-items-center">
                                        <h3 className="sub-heading">Client Outreach Summaries</h3>
                                    </div>

                                    <div className="card-body">
                                        <div className="table-responsive data-table-wrapper table-heading">
                                            <Table
                                                data={data}
                                                columns={columnSchema}
                                                remote={true}
                                                id="id"
                                                total={totalElements}
                                                getData={loadData}
                                                apiUrl="client-outreach/list"
                                                defaultSort="id"
                                                defaultOrder="asc"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
            {loading && (
                <div className="overlay">
                    <Loader loading={loading} />
                </div>
            )}
        </div>
    );
}

export default ClientOutreachSummaries;